import { IconButton, ListItemSecondaryAction, Tooltip } from '@material-ui/core'
import { Delete, Edit } from '@material-ui/icons'
import React from 'react'

const SavedLocationActions = ({ handleDeleteClick, handleEditClick, numLocations }) => {
  return (
    <ListItemSecondaryAction>
      <Tooltip title="Edit">
        <IconButton onClick={handleEditClick}>
          <Edit />
        </IconButton>
      </Tooltip>
      {/* If only one location available, hide delete button */}
      {numLocations !== 1 && (
        <Tooltip title="Delete">
          <IconButton onClick={handleDeleteClick}>
            <Delete />
          </IconButton>
        </Tooltip>
      )}
    </ListItemSecondaryAction>
  )
}

export default SavedLocationActions
